/*
 * Copyright (c) Jupyter Development Team.
 * Distributed under the terms of the Modified BSD License.
 */
import { caretDownEmptyThinIcon } from '@jupyterlab/ui-components';
import * as React from 'react';
export class ShortcutTitleItem extends React.Component {
    render() {
        return (React.createElement("div", { className: this.props.title.toLowerCase() === this.props.active
                ? 'jp-Shortcuts-Header jp-Shortcuts-CurrentHeader'
                : 'jp-Shortcuts-Header', onClick: () => this.props.updateSort(this.props.columnId) },
            this.props.title,
            React.createElement(caretDownEmptyThinIcon.react, { className: 'jp-Shortcuts-SortButton jp-ShortcutTitleItem-sortButton' })));
    }
}
//# sourceMappingURL=ShortcutTitleItem.js.map